import { render } from "./SelectedFilters.vue?vue&type=template&id=71b0f0a7"
import script from "./SelectedFilters.vue?vue&type=script&lang=js"
export * from "./SelectedFilters.vue?vue&type=script&lang=js"

import "./SelectedFilters.vue?vue&type=style&index=0&id=71b0f0a7&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__